import { createAuthComponentsPlugin } from "@hereby/components";
import { reportSessionAdoption } from "@hereby/components/analytics";
import { createAlpinePlugin } from "@hereby/sdk";
import Alpine from "alpinejs";
import { appComponent } from "./app";
import { createRouterStore } from "./router";
import "./styles/main.css";

// Register SDK plugin (provides $store.hereby with auth state + SDK client)
Alpine.plugin(
  createAlpinePlugin({
    onSessionAdopted: reportSessionAdoption("module_manager"),
    appId: "module-manager",
    baseUrl: import.meta.env.API_BASE_URL,
  }),
);

// Register Components plugin (provides loginForm component)
Alpine.plugin(createAuthComponentsPlugin());

// Register router store
Alpine.store("router", createRouterStore());

// Register the main app component
Alpine.data("_app", appComponent);

// Start Alpine
Alpine.start();
